export enum ActionTypes {
    SET_IS_AUTHENTICATED = "SET_IS_AUTHENTICATED",
    SET_USER_DETAILS = "SET_USER_DETAILS",
    CLEAR_REDUX = "CLEAR_REDUX",
    SET_CURRENT_PAGE = "SET_CURRENT_PAGE"
}
